import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import ArrowUpSvg from '@/assets/ArrowUp.svg';

const ArrowUp = ({ size, variant, className }: IconProps) => (
  <img
    src={ArrowUpSvg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default ArrowUp;
